// Auth namespace — shared by Login.tsx and Register.tsx (public pages).
// Keys mirror en/auth.ts exactly. EXACT current Polish strings, verbatim.
export const auth = {
  login: {
    heading: 'Witaj ponownie',
    emailLabel: 'E-mail',
    emailPlaceholder: 'ty@twojlabel.pl',
    passwordLabel: 'Hasło',
    forgot: 'Nie pamiętasz hasła?',
    submit: 'Zaloguj się',
    submitBusy: 'Logowanie…',
    noAccount: 'Nie masz konta?',
    signUp: 'Załóż za darmo',
    // Tylko o danych logowania — krócej niż wcześniej (brzmienie planu, artboard 04b).
    // Niepotwierdzony adres ma WŁASNE zdanie i własne wyjście, więc to zdanie może być
    // wreszcie prawdziwe o haśle.
    error: 'Zły e-mail lub hasło.',
    // Artboard 04c: stan z ponowną wysyłką musi powiedzieć, CZEMU logowanie nie przeszło.
    unverified: 'Adres nie jest potwierdzony.',
    // Wyjście z jedynego ślepego zaułka, jaki ma ten ekran: konto istnieje, hasło
    // się zgadza, a zalogować się nie da, bo adres nie jest potwierdzony. Endpoint
    // (`/auth/resend-verification`) był publiczny od początku — brakowało miejsca,
    // z którego klient mógłby go użyć.
    resend: 'Wyślij link jeszcze raz',
    resendBusy: 'Wysyłanie…',
    resendSent: 'Nowy link wysłany. Sprawdź skrzynkę i spam.',
    // 5 prób na godzinę (limiter po stronie serwera). Zdanie mówi, co robić dalej,
    // a nie „błąd 429".
    resendFailed: 'Nie udało się wysłać linku. Spróbuj za chwilę.',
  },
  // Odzyskiwanie hasla — DWA ekrany w SPA (wczesniej: link WYCHODZACY z aplikacji
  // na stronę renderowaną serwerowo, z innym layoutem i polskim flashem).
  forgot: {
    heading: 'Nie pamiętasz hasła?',
    emailLabel: 'E-mail',
    submit: 'Wyślij link',
    submitBusy: 'Wysyłanie…',
    // NIGDY nie mówimy, czy konto istnieje — backend odpowiada identycznie w obu
    // przypadkach (anty-enumeracja §9) i ten ekran nie ma prawa tego zdradzić.
    doneHeading: 'Sprawdź skrzynkę',
    // Adres jest wytłuszczony w środku zdania, więc zdanie ma dwie połowy (artboard 05b).
    doneBefore: 'Jeśli takie konto istnieje, link już jedzie na ',
    doneAfter: '.',
    // Fakt bezpieczeństwa, nie ozdoba: stoi i po wysłaniu linku, i przy martwym linku.
    linkLife: 'Link działa 30 minut, tylko raz.',
    backToLogin: 'Wróć do logowania',
    networkError: 'Nie udało się połączyć z serwerem. Spróbuj ponownie za chwilę.',
  },
  reset: {
    heading: 'Ustaw nowe hasło',
    passwordLabel: 'Nowe hasło',
    confirmLabel: 'Powtórz hasło',
    // Regula podana Z GORY, nie po odrzuceniu formularza.
    hint: 'Min. 8 znaków, cyfra i wielka litera.',
    mismatch: 'Hasła się różnią.',
    weak: 'Hasło jest za słabe - min. 8 znaków, w tym cyfra i wielka litera.',
    submit: 'Zapisz nowe hasło',
    submitBusy: 'Zapisuję…',
    deadHeading: 'Ten link już nie działa',
    dead: 'Link do zmiany hasła jest nieprawidłowy, został już użyty albo wygasł.',
    requestNew: 'Wyślij nowy link',
    signOutNote: 'Zmiana hasła wyloguje wszystkie urządzenia.',
  },
  // Komunikaty po powrocie z linku w mailu (query string, patrz _spa_login w app/auth/routes.py).
  banner: {
    verified: 'E-mail potwierdzony.',
    verifyError: 'Link weryfikacyjny jest nieprawidłowy albo wygasł. Zaloguj się i poproś o nowy.',
    // 0017 pkt 7: link, który wystawiliśmy, ale zastąpił go nowszy albo minął jego termin.
    verifyExpired: 'Ten link już nie działa - poprosiłeś o nowy albo minął jego termin. Zaloguj się i poproś o nowy.',
    passwordReset: 'Hasło zmienione. Zaloguj się nowym hasłem.',
    emailChanged: 'Adres e-mail zmieniony. Zaloguj się nowym adresem.',
    emailTaken: 'Ten adres e-mail jest już zajęty - zmiana nie została wykonana.',
    emailChangeError: 'Link zmiany adresu e-mail jest nieprawidłowy albo wygasł.',
  },
  register: {
    heading: 'Załóż konto',
    emailLabel: 'E-mail',
    emailPlaceholder: 'ty@twojlabel.pl',
    passwordLabel: 'Hasło',
    acceptPrefix: 'Akceptuję',
    terms: 'Regulamin',
    acceptAnd: 'i',
    privacy: 'Politykę prywatności',
    submit: 'Załóż konto',
    submitBusy: 'Tworzenie…',
    // Warstwa pewności POD przyciskiem (artboardy 06a, 06ab, 06b): jedno zdanie
    // o karcie i nazwa dokumentu, pod którym się podpisujesz. Nie jest to zgoda —
    // teksty zgód stoją wyżej i są strefą chronioną.
    noCard: 'Bez karty.',
    haveAccount: 'Masz już konto?',
    signIn: 'Zaloguj się',
    error: 'Nie udało się założyć konta. Spróbuj jeszcze raz.',
    // Błędy POD POLAMI zamiast jednego zdania zbiorczego (MAPA 37, nowe teksty).
    err: {
      email: 'Podaj poprawny adres e-mail.',
      terms: 'Zaznacz zgodę, żeby założyć konto.',
    },
    // 02a/02b (0017, projekt 01): ekran bez powłoki po rejestracji i po ponownej wysyłce.
    // Wersja A z MAPA: od 0017 nowy link unieważnia poprzedni (pkt 7), więc copy może to mówić.
    // MAPA 01 wskazuje `register.doneBody` jako istniejący; ekran czyta `register.check.*`.
    check: {
      heading: 'Sprawdź skrzynkę',
      // Adres wytłuszczony w środku zdania (artboard 06c).
      sentBefore: 'Wysłaliśmy link na ',
      sentAfter: '.',
      resend: 'Wyślij link jeszcze raz',
      resendBusy: 'Wysyłanie…',
      // Blokada 60 s po stronie klienta (odliczanie na przycisku) — bez obietnicy limitu serwera.
      resendWait: 'Wyślij link jeszcze raz ({s} s)',
      resendFailed: 'Nie udało się wysłać linku. Spróbuj za chwilę.',
      wrong: 'Zły adres?',
      again: 'Zarejestruj się ponownie',
    },
  },
}
